import { useQuery } from "@tanstack/react-query";

import { canLogin } from "~/api";

export const useCanLogin = (email: string, trigger: number) => {
  return useQuery({
    queryKey: ["canLogin", email, trigger],
    queryFn: () => canLogin(email),
    enabled: !!email,
    staleTime: 0,
  });
};
